import React, { useEffect, useState } from "react";

export default function Header() {
  const [isFixed, setIsFixed] = useState(false);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // You can adjust this threshold as needed
      if (window.scrollY > 100) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMobileNav = () => {
    setMobileNavOpen((prev) => !prev);
  };

  // Add or remove class from <body> based on state
  useEffect(() => {
    const body = document.body;

    if (isMobileNavOpen) {
      body.classList.add("mobile-nav-active");
    } else {
      body.classList.remove("mobile-nav-active");
    }

    // Clean up on component unmount
    return () => body.classList.remove("mobile-nav-active");
  }, [isMobileNavOpen]);

  return (
    <header
      id="header"
      className={`header d-flex align-items-center fixed-top ${
        isFixed ? "fixed_top" : ""
      }`}
    >
      <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
        <a
          href="#about"
          className="logo d-flex align-items-center me-auto me-xl-0"
        >
          {/* <img src="assets/img/logo.png" alt="logo" /> */}
          <h1 className="sitename">
            <b>Magfrai</b>
          </h1>
        </a>

        <nav
          id="navmenu"
          className={`navmenu ${isMobileNavOpen ? "navmenu-active" : ""}`}
        >
          <ul>
            <li>
              <a href="#hero" className="active">
                Home
              </a>
            </li>
            <li>
              <a href="#about">About</a>
            </li>
            <li>
              <a href="#features">Features</a>
            </li>
            <li>
              <a href="#services">Services</a>
            </li>

            {/* <li className="dropdown"><a href="#"><span>Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                            <ul>
                                <li><a href="#">Dropdown 1</a></li>
                                <li className="dropdown"><a href="#"><span>Deep Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                                    <ul>
                                        <li><a href="#">Deep Dropdown 1</a></li>
                                        <li><a href="#">Deep Dropdown 2</a></li>
                                        <li><a href="#">Deep Dropdown 3</a></li>
                                        <li><a href="#">Deep Dropdown 4</a></li>
                                        <li><a href="#">Deep Dropdown 5</a></li>
                                    </ul>
                                </li>
                                <li><a href="#">Dropdown 2</a></li>
                                <li><a href="#">Dropdown 3</a></li>
                                <li><a href="#">Dropdown 4</a></li>
                            </ul>
                        </li> */}
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
          {/* <i className="mobile-nav-toggle d-xl-none bi bi-list"></i> */}
          <i
            className={`mobile-nav-toggle d-xl-none bi ${
              isMobileNavOpen ? "bi-x" : "bi-list"
            }`}
            onClick={toggleMobileNav}
          ></i>
        </nav>
        <a className="btn-getstarted" href="#contact">
          Get Started
        </a>
      </div>
    </header>
  );
}
